import { useTranslation } from '../../lib/i18n'

export default function WeaveRequestedNotification({ notification }) {
  const { t } = useTranslation()
  return (
    <>
      <p className="w-full max-w-200 md:max-w-300 truncate overflow-hidden">
        <span className="text-off-black font-bold">
          {notification.notifiable?.sender?.name}
        </span>{' '}
        {t('common.sentYouAWeaveRequest')}
      </p>
    </>
  )
}
